export const carouselSlider = (value, dataLength) => {
  const slide = value <= dataLength ? value : dataLength || 1;
  return slide;
};
